import { useFormikContext, useField } from 'formik'
import { useCallback, useMemo, useEffect } from 'react'
import { ILeadFormModel } from '../../../typings'
import { ISalesFunnelStage } from '@user/store/salesFunnel'

type Props = {
  name: string
  salesFunnelStages: ISalesFunnelStage[]
  required: boolean
}
export function useData(props: Props) {
  const { name, salesFunnelStages, required } = props
  const options = salesFunnelStages

  const { setFieldValue, isSubmitting, values } =
    useFormikContext<ILeadFormModel>()

  const salesFunnelStageId = useMemo(() => values[name], [values, name])

  const [{}, { error, touched }] = useField<string[]>({
    name,
    validate: (value) => {
      if (required && !value) {
        return 'Required'
      }
    },
  })

  const showError =
    required !== undefined
      ? Boolean(required && error && touched)
      : Boolean(error && touched)
  const helperText = showError ? error : ''

  const getLabel = useCallback(
    (option: ISalesFunnelStage) => `${option?.name}`,
    [],
  )

  const getId = useCallback((option: ISalesFunnelStage) => {
    return String(option.id)
  }, [])

  useEffect(() => {
    if (!salesFunnelStageId && options?.length == 1) {
      setFieldValue(name, options[0].id)
    }
  }, [name, options, salesFunnelStageId, setFieldValue])

  const initialOption = useMemo(() => {
    if (salesFunnelStageId) {
      const value = options.find((x) => x.id === parseInt(salesFunnelStageId))
      if (value) return value
    }
    return null
  }, [options, salesFunnelStageId])

  useEffect(() => {
    if (salesFunnelStageId == '' && initialOption) {
      setFieldValue('salesFunnelStageId', initialOption.id)
    }
  }, [salesFunnelStageId, initialOption, setFieldValue])

  return {
    getLabel,
    getId,
    items: options,
    initialOption,
    isSubmitting,
    showError,
    helperText,
  }
}
